import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FieldGroupDynamicStyleConstantType,
    FieldGroupDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    isOptionList,
    spaces
}: FieldGroupDynamicStyleConstantType): FieldGroupDynamicStyleType => {
    return {
        container: {
            gap: isOptionList ? 0 : spaces.spacingMd
        } as Mutable<ViewStyle>
    };
};
export default stylesheet;
